import React from "react";

const ItemCard = ({title,name,value}) => {
  return (
    <div>
      <h4 className="view-heading">{title}</h4>
      <section>
        <label htmlFor={name}>{value}</label>
      </section>
    </div>
  );
};

export default ItemCard;
